<template>
    <div class="d-flex flex-column flex-root">
  
      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
  
        <!--begin::Content-->
  
        <div
          class="flex-row-fluid d-flex flex-column position-relative overflow-hidden landing bg-color1 bg-images"
        >
          <div class="container">
            <v-row no-gutters>
              <v-col>
                <h1 class="mt-10 quiz-title">Quiz - {{title}}</h1>
              </v-col>
            </v-row>
          </div>

          <div class="quiz-content d-flex flex-column bg-color2">
            <div class="container">
              <v-row no-gutters v-if="!showResult">
                <v-col lg="2" md="4" sm="12" cols="12" class="timer-content">
                  <p>Tiempo</p>
                  <div class="timer-widget">
                    {{showingTime}}
                  </div>
                </v-col>
                <v-col lg="8" md="4" sm="12" cols="12" class="media-content text-center">
                  <p>{{currentQuiz.question}}</p>
                  <div class="media-widget" v-if="currentQuiz.mediaType != 'blank'">
                    <img :src="currentQuiz.media" v-if="currentQuiz.mediaType == 'image'">
                    <vimeo-player ref="player"
                      class="vimeo-player text-center"
                      v-if="currentQuiz.mediaType == 'video'"
                      :video-id="currentQuiz.media" 
                      :player-width="1000"  
                      :player-height="600" 
                      :options="options">
                    </vimeo-player>
                  </div>
                </v-col>
                <v-col lg="2" md="4" sm="12" cols="12" class="step-content">
                  <p>Prueba</p>
                  <div class="step-widget mb-5">
                    {{step+1}} de {{length}}
                  </div>
                  <div class="step-result" :class="
                    correctAnswers[step] == answers[step] ? 'success' : 'failed'
                  " v-if="timer == null">
                    <div class="step-status" v-if="timer == null">
                      <span class="fa fa-check-circle" v-if="correctAnswers[step] == answers[step]"></span>
                      <span class="fa fa-times-circle" v-if="correctAnswers[step] != answers[step]"></span>
                    </div>
                    <div class="step-description" v-if="timer == null">
                      <span v-if="correctAnswers[step] == answers[step]">¡Tu respuesta es correcta!</span>
                      <span v-if="correctAnswers[step] != answers[step] && answers[step] != ''">¡Tu respuesta es incorrecta!</span>
                      <span v-if="answers[step] == ''">Se acabó el tiempo</span>
                    </div>
                  </div>
                  <v-btn rounded  class="text-capitalize startlesson" @click="startQuiz(step+1)" v-if="step < length-1">Siguiente <span class="material-icons">arrow_forward_ios</span></v-btn>
                  <v-btn rounded  class="text-capitalize startlesson" @click="onResult()" v-if="(step == length - 1)">Resultado <span class="material-icons">arrow_forward_ios</span></v-btn>
                </v-col>
              </v-row>
              <v-row no-gutters v-if="showResult">
                <v-col lg="2">
                </v-col>
                <v-col lg="8" md="12" sm="12" cols="12" class="media-content text-center step-content">
                  <p>Tu puntaje es {{yourScore}} / {{totalScore}}</p>
                  <v-row no-gutters>
                    <v-col cols="6" v-for="(item, index) in answers" v-bind:key="index">
                      <div class="step-result" :class="
                          correctAnswers[index] == answers[index] ? 'success' : 'failed'
                        ">
                        <b class="step-number"> {{(index + 1)}} </b>
                        <div class="step-status">
                          <span class="fa fa-check-circle" v-if="correctAnswers[index] == answers[index]"></span>
                          <span class="fa fa-times-circle" v-if="correctAnswers[index] != answers[index]"></span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-btn rounded  class="text-capitalize startlesson retry" @click="onRetry()">Rever <span class="material-icons">refresh</span></v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn rounded  class="text-capitalize startlesson" @click="onFinish()">Finalizar <span class="material-icons">arrow_forward_ios</span></v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col lg="2">
                </v-col>
              </v-row>
            </div>
          </div>

          <div class="container mb-10" v-if="!showResult">
            <v-row no-gutters>
              <v-col lg="6" md="6" sm="12" cols="12" @click="selectQuestion('A')">
                <div class="e-answers A d-flex" :class="[
                  'A' == answers[step] ? 'selected': ''
                ]">
                  <div class="e-header">
                    A
                  </div>
                  <div class="e-content">
                    {{currentQuiz.answerA}}
                  </div>
                  <div class="e-status">
                    <span class="fa fa-check-circle" v-if="'A' == answers[step] && 'A' == correctAnswers[step]"></span>
                    <span class="fa fa-times-circle" v-if="'A' == answers[step] && 'A' != correctAnswers[step]"></span>
                  </div>
                </div>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12" @click="selectQuestion('B')">
                <div class="e-answers B d-flex" :class="[
                  'B' == answers[step] ? 'selected': ''
                ]">
                  <div class="e-header">
                    B
                  </div>
                  <div class="e-content">
                    {{currentQuiz.answerB}}
                  </div>
                  <div class="e-status">
                    <span class="fa fa-check-circle" v-if="'B' == answers[step] && 'B' == correctAnswers[step]"></span>
                    <span class="fa fa-times-circle" v-if="'B' == answers[step] && 'B' != correctAnswers[step]"></span>
                  </div>
                </div>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12" @click="selectQuestion('C')">
                <div class="e-answers C d-flex" :class="[
                  'C' == answers[step] ? 'selected': ''
                ]">
                  <div class="e-header">
                    C
                  </div>
                  <div class="e-content">
                    {{currentQuiz.answerC}}
                  </div>
                  <div class="e-status">
                    <span class="fa fa-check-circle" v-if="'C' == answers[step] && 'C' == correctAnswers[step]"></span>
                    <span class="fa fa-times-circle" v-if="'C' == answers[step] && 'C' != correctAnswers[step]"></span>
                  </div>
                </div>
              </v-col>
              <v-col lg="6" md="6" sm="12" col="12" @click="selectQuestion('D')">
                <div class="e-answers D d-flex" :class="[
                  'D' == answers[step] ? 'selected': ''
                ]">
                  <div class="e-header">
                    D
                  </div>
                  <div class="e-content">
                    {{currentQuiz.answerD}}
                  </div>
                  <div class="e-status">
                    <span class="fa fa-check-circle" v-if="'D' == answers[step] && 'D' == correctAnswers[step]"></span>
                    <span class="fa fa-times-circle" v-if="'D' == answers[step] && 'D' != correctAnswers[step]"></span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <!--end::Content-->
      </div>
  
    </div>
  </template>
  
  <!-- Load login custom page styles -->
  <style lang="scss">
  @import "@/assets/sass/pages/landing/landing.scss";
  </style>
  
  <script>
  
  import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
  } from "@/core/services/store/htmlclass.module.js";
  import {
    POST_PROGRESS_DATA,
  } from "@/core/services/store/progress.module.js";
  import { mapGetters } from "vuex";
  import { GET_QUESTION_DATA } from "../../../core/services/store/data.module";
  
  
  export default {
    name: "quiz",
    components: {
    },
    data() {
        return {
            id: this.$route.params.id,
            title: this.$route.params.title,
            questions: [],
            seconds: 0,
            recordTime: 0,
            currentQuiz: {},
            answers: [],
            correctAnswers: [],
            length: 0,
            step: 0,
            videoID: "",
            timer: null,
            recordTimer: null,
            showResult: false,
            totalScore: 0,
            yourScore: 0,
            options: {
                muted: false,
                autoplay: true,
                controls: true,
            },
        }
    },
    created() {
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      this.recordTimer = setInterval(function() {
        this.recordTime++;
        console.log(this.recordTime);
      }.bind(this), 1000);
  
      this.$store
            .dispatch(GET_QUESTION_DATA, this.id)
            .then(() => {
              this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
              this.questions = this.questionData;
              for(var i in this.questions) {
                this.correctAnswers.push(this.questions[i].correct);
                this.answers.push('');
              }
              this.length = this.questions.length;

              if(this.questions.length > 0) {
                this.startQuiz(0);
              }
            })
            .catch(() => {
                  this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            });
    },
    beforeDestroy() {
      if(this.recordTimer != null) {
          clearInterval(this.recordTimer);
          this.recordTimer = null;
        }
        if(this.timer != null) {
          clearInterval(this.timer);
          this.timer = null;
        }
    },
    methods: {
      startQuiz(index) {
        if(this.timer != null) {
          this.stopTimer();
        }
        this.step = index;
        this.currentQuiz = this.questions[index];
        this.seconds = this.currentQuiz.time;
        this.startTimer();
      },

      selectQuestion(qa) {
        if(this.timer != null) {
          this.answers[this.step] = qa;
        }
        this.stopTimer();
      },
      
      startTimer() {

        this.timer = setInterval(function () {
          this.seconds--;
          if(this.seconds == 0) {
            this.stopTimer();
          }
        }.bind(this), 1000);
      },

      stopTimer() {

        if(this.timer != null) {
          clearInterval(this.timer);
          this.timer = null;
          if(this.seconds != 0) {
            this.seconds--;
          }
        }
      },
      
      onResult() {
        this.totalScore = this.answers.length;
        this.yourScore = 0;
        for(let i in this.answers) {
          if(this.answers[i] === this.correctAnswers[i]) {
            this.yourScore ++;
          }
        }
        this.showResult = true;
      },

      onRetry() {
        this.showResult = false;
        this.startQuiz(0);
      },

      onFinish() {
        var params = {
          lesson_id: this.id,
          count: this.totalScore,
          time: this.recordTime,
          points: this.yourScore,
          title: this.title,
        };

        this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
        this.$store
          .dispatch(POST_PROGRESS_DATA, params)
          .then(() => {
              this.$router.go(-1);
          })
          .catch(() => {
              
          });
      }
    },
    computed: {
      ...mapGetters([
          "questionData"
      ]),
      showingTime() {
        return  new Date(this.seconds * 1000).toISOString().slice(14, 19);
      }
    }
  };
  </script>
  